(function () {
  'use strict';

  var COLLAPSE_LIMIT = 2;
  var ROOT_SELECTOR = '#shopify-section-template--1782375626c7c1f805__1782375626c7c1f805, [id*="1782375626c7c1f805"], [class*="lai"][class*="review"], [id*="lai"][id*="review"]';
  var ITEM_SELECTORS = [
    '[class*="review-card"]',
    '[class*="review_item"]',
    '[class*="review-item"]',
    '[class*="ReviewItem"]',
    '[class*="review-list"] > *',
    '[class*="reviews-list"] > *',
    '[data-review-id]',
    '[data-id][class*="review"]'
  ];
  var CONTROL_WORDS = [
    'レビューを書く',
    'すべてのレビュー',
    'レビューを並べ替える',
    'レビューをもっと見る',
    'レビューを閉じる'
  ];

  function hasText(element, text) {
    return (element.textContent || '').indexOf(text) !== -1;
  }

  function isLikelyControl(element) {
    var text = (element.textContent || '').trim();

    if (!text) {
      return true;
    }

    if (element.matches('button, select, option, input, form, summary')) {
      return true;
    }

    return CONTROL_WORDS.some(function (word) {
      return text.indexOf(word) !== -1;
    });
  }

  function isReviewItem(element, root) {
    if (!element || element === root || element.classList.contains('lai-review-collapse__toggle-wrap')) {
      return false;
    }

    if (isLikelyControl(element)) {
      return false;
    }

    var text = (element.textContent || '').trim();
    if (text.length < 12) {
      return false;
    }

    var hasDate = /\d{4}[\/.-]\d{1,2}[\/.-]\d{1,2}/.test(text);
    var hasStar = /★|☆|スター|星/.test(text);
    var hasParagraph = element.querySelector('p, [class*="content"], [class*="body"], [class*="comment"], [class*="text"]');
    var hasReviewClass = /review/i.test(element.className || '');

    if (!hasDate && !hasStar && !hasReviewClass && !hasParagraph) {
      return false;
    }

    var nestedItems = element.querySelectorAll(ITEM_SELECTORS.join(','));
    if (nestedItems.length > 1) {
      return false;
    }

    return true;
  }

  function uniqueElements(elements) {
    var seen = [];
    Array.prototype.forEach.call(elements, function (element) {
      if (seen.indexOf(element) === -1) {
        seen.push(element);
      }
    });
    return seen;
  }

  function getRoots() {
    var roots = uniqueElements(document.querySelectorAll(ROOT_SELECTOR));
    return roots.filter(function (root) {
      return /レビュー|review|lai/i.test([root.id, root.className, root.textContent].join(' '));
    });
  }

  function findReviewItems(root) {
    var candidates = uniqueElements(root.querySelectorAll(ITEM_SELECTORS.join(',')));
    var items = candidates.filter(function (element) {
      return isReviewItem(element, root);
    });

    if (items.length <= 1) {
      var fallback = Array.prototype.filter.call(root.children, function (element) {
        return isReviewItem(element, root);
      });
      items = items.concat(fallback);
    }

    return uniqueElements(items).filter(function (item) {
      return !items.some(function (other) {
        return other !== item && other.contains(item) && isReviewItem(other, root);
      });
    });
  }

  function createButton(root) {
    var wrap = root.querySelector(':scope > .lai-review-collapse__toggle-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'lai-review-collapse__toggle-wrap';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'lai-review-collapse__toggle';
      button.setAttribute('aria-expanded', 'false');
      button.innerHTML = '<span class="lai-review-collapse__toggle-text">レビューをもっと見る</span><span class="lai-review-collapse__toggle-icon" aria-hidden="true"></span>';
      button.addEventListener('click', function () {
        var expanded = root.classList.toggle('lai-review-collapse--expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.querySelector('.lai-review-collapse__toggle-text').textContent = expanded ? 'レビューを閉じる' : 'レビューをもっと見る';
        applyCollapse(root);
      });

      wrap.appendChild(button);
    }

    return wrap;
  }

  function insertAfterLastItem(root, items, wrap) {
    var lastItem = items[items.length - 1];
    if (!lastItem) {
      return;
    }
    if (lastItem.nextElementSibling !== wrap) {
      lastItem.insertAdjacentElement('afterend', wrap);
    }
  }

  function resetPrevious(root) {
    root.querySelectorAll('.lai-review-collapse__hidden').forEach(function (element) {
      element.classList.remove('lai-review-collapse__hidden');
    });
  }

  function applyCollapse(root) {
    if (root.dataset.laiReviewCollapseApplying === 'true') {
      return;
    }

    root.dataset.laiReviewCollapseApplying = 'true';
    resetPrevious(root);

    var items = findReviewItems(root);
    var wrap = root.querySelector(':scope > .lai-review-collapse__toggle-wrap');

    if (items.length <= COLLAPSE_LIMIT) {
      root.classList.remove('lai-review-collapse', 'lai-review-collapse--expanded');
      if (wrap) {
        wrap.remove();
      }
      root.dataset.laiReviewCollapseApplying = 'false';
      return;
    }

    root.classList.add('lai-review-collapse');
    var expanded = root.classList.contains('lai-review-collapse--expanded');

    items.forEach(function (item, index) {
      if (!expanded && index >= COLLAPSE_LIMIT) {
        item.classList.add('lai-review-collapse__hidden');
      }
    });

    wrap = createButton(root);
    insertAfterLastItem(root, expanded ? items : items.slice(0, COLLAPSE_LIMIT), wrap);

    root.dataset.laiReviewCollapseApplying = 'false';
  }

  function setupRoot(root) {
    if (root.dataset.laiReviewCollapseReady === 'true') {
      applyCollapse(root);
      return;
    }

    root.dataset.laiReviewCollapseReady = 'true';
    applyCollapse(root);

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (root.dataset.laiReviewCollapseApplying === 'true') {
        return;
      }
      if (scheduled) {
        return;
      }
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        applyCollapse(root);
      });
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function init() {
    getRoots().forEach(setupRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
  window.setTimeout(init, 800);
  window.setTimeout(init, 1800);
  window.setTimeout(init, 3500);
})();
